export const Config = {
  API_HOST: "https://pag-online-api.gljiva.net",
  IMAGE_HOST: "https://d2j3k6b3eqju6r.cloudfront.net",
  APP_URL: "https://pag-city.online/",
  RESIZE_FORMATS: [86, 160, 320, 480, 540, 720, 960, 1140],
};
